import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Col, Container, Input } from 'reactstrap';

import Breadcrumb from 'Components/Common/Breadcrumb';
import Pagination from 'Components/Common/Pagination';
import { handleAxiosError } from 'helpers/handleError';
import useTitle from 'hooks/useTitle';
import EventCoreService from 'services/event-core.service';
import { EventVerificationForAdmins } from 'types/core';

import Filter from '../../../assets/svg/Group702.svg';
import VerificationRequestCard from '../VerificationRequestCard';

const limit = 12;

const EventVerificationRequests = () => {
  useTitle('Verification requests', {
    restoreOnUnmount: true,
  });

  const [requestCount, setRequestCount] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [queryFilter, setQueryFilter] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [eventVerificationList, setEventVerificationList] = useState<EventVerificationForAdmins[]>(
    []
  );
  const getEventVerificationList = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await EventCoreService.getVerificationEvents({
        limit,
        offset: (currentPage - 1) * limit,
        order: 'asc',
        filter: queryFilter,
      });
      const { payload } = data;
      const filteredEvents = payload.verifications;
      setEventVerificationList(filteredEvents);
      setRequestCount(payload.count);
      // setEventCount(filteredEvents.length)
    } catch (error) {
      handleAxiosError(error, (message) => toast.error(message));
    } finally {
      setLoading(false);
    }
  }, [queryFilter, currentPage]);

  useEffect(() => {
    getEventVerificationList();
  }, [getEventVerificationList]);

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumb title='Event' breadcrumbItem='Event verification requests' />
        </Container>
        <Col>
          <Card className=' tw-overflow-hidden'>
            <div className='tw-flex tw-w-full tw-items-center tw-justify-between tw-p-4'>
              <div className='tw-font-bold tw-text-left'>Verification requests</div>
              <div className='tw-text-right tw-flex tw-flex-row tw-gap-2'>
                <div>
                  <Input
                    id='orderSelect'
                    className='form-control !tw-w-full xs:!tw-w-[8rem] tw-h-[38px] tw-items-center tw-justify-center'
                    name='orderSelect'
                    defaultValue='false'
                    value={queryFilter.toString()}
                    onChange={(e) => {
                      setQueryFilter(e.target.value === 'true');
                    }}
                    type='select'
                    placeholder='Order'
                  >
                    <option key='notVerified' value='false'>
                      Not Verified
                    </option>
                    <option key='verified' value='true'>
                      Verified
                    </option>
                  </Input>
                </div>
                <img alt={'filter'} src={Filter} />
              </div>
            </div>
            <div className='tw-relative tw-flex tw-flex-col tw-w-full tw-gap-5 tw-p-4'>
              <div className='tw-relative tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-[1rem] tw-justify-items-center'>
                {eventVerificationList.length > 0 && !loading ? (
                  eventVerificationList.map((eventVerification) => (
                    <VerificationRequestCard
                      key={eventVerification._id}
                      eventVerification={eventVerification}
                      isShowVerify={eventVerification.isVerified}
                    />
                  ))
                ) : (
                  <div></div>
                )}
              </div>
              <Pagination
                count={requestCount}
                pageSize={limit}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </Card>
        </Col>
      </div>
    </React.Fragment>
  );
};

export default EventVerificationRequests;
